import * as React from 'react';
import styled from 'styled-components';
import { LazyImage } from 'components/LazyImage';
import { Typography } from 'components/DesignSystemV2/Typography';
import { colorsV2 } from 'style/colors-v2';
import { flexGap, imageFitStyle } from 'style/css-style';

const Main = styled.a`
  display: grid;
  align-content: space-between;
  gap: 16px;
`;

const TeacherImage = styled.div`
  aspect-ratio: 360/240;
  border-radius: 20px;
  overflow: hidden;
  position: relative;

  img {
    ${imageFitStyle('cover')}
  }
`;

const MainContent = styled.div`
  display: grid;
  gap: 8px;
`;

const OtherContent = styled.div`
  display: grid;
  gap: 8px;
`;

const Teacher = styled.div`
  display: flex;
  align-items: center;
  ${flexGap(8)};
`;

const UpdatedAt = styled.div`
  font-style: italic;
`;

export const CourseTeacherCard = ({
  listingImageHandler = '',
  name = '',
  description = '',
  displayName = '',
  updatedAt = '',
  linkLevel = ''
}) => {
  return (
    <Main href={linkLevel} target="_blank" rel="noopener noreferrer">
      <TeacherImage>
        <LazyImage
          className="teacher-image"
          handle={listingImageHandler}
          alt={name}
        />
      </TeacherImage>
      <MainContent>
        <Typography variant="semi-bold/18-24" color={colorsV2.neutral180}>
          {name}
        </Typography>
        <Typography variant="regular/16-24" color={colorsV2.neutral180}>
          {description}
        </Typography>
        <OtherContent>
          <Teacher>
            <Typography variant="regular/16-24" color={colorsV2.neutral140}>
              Giáo viên: {displayName}
            </Typography>
          </Teacher>
          <UpdatedAt>
            <Typography variant="regular/14-16" color={colorsV2.blue80}>
              {updatedAt || 'Updated in December 2022'}
            </Typography>
          </UpdatedAt>
        </OtherContent>
      </MainContent>
    </Main>
  );
};
